import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@mui/material/Checkbox';
import CheckIcon from '@mui/icons-material/Check';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText'; 
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { makeStyles } from "@material-ui/core/styles";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
//import TagsOptions from '../components/TagsOptions';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import { Editor } from '@tinymce/tinymce-react';
import $ from 'jquery';
// Load wiris formula render script.
const jsDemoImagesTransform = document.createElement('script');
jsDemoImagesTransform.type = 'text/javascript';
jsDemoImagesTransform.src = 'https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image';
document.head.appendChild(jsDemoImagesTransform);
// This needs to be included before the '@wiris/mathtype-tinymce6' is loaded synchronously
window.$ = $;
window.tinymce = require('tinymce');  // Expose the TinyMCE to the window.
// Load wiris plugin synchronously.
require('@wiris/mathtype-tinymce6');


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles({
  paper: {
    fontSize: '12px !important',    
  }
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const editorRef = React.useRef(null);
  const userObj = useSelector(state => state.userDetails);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [filterTopics, setFilterTopics] = React.useState("BIO");
  const [selectedIndex, setSelectedIndex] = React.useState(-1);

  const [gradeList, setGradeList] = React.useState([]);
  const [languageList, setLanguageList] = React.useState([]);

  const [hideShow, setHideShow] = React.useState(false);
  const [topicId, setTopicId] = React.useState(0);
  const [topicName, setTopicName] = React.useState("");
  const [contentName, setContentName] = React.useState("");
  const [contentUrl, setContentUrl] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [contentType, setContentType] = React.useState("noselect");
  const [contentSource, setContentSource] = React.useState("noselect");
  const [contentSourceArr, setContentSourceArr] = React.useState([]);
  const [sequence, setSequence] = React.useState(1);
  const [gradeId, setGradeId] = React.useState(0);
  const [gradeName, setGradeName] = React.useState("");
  const [language, setLanguage] = React.useState("English");
  const [country, setCountry] = React.useState("noselect");
  const [contentFilePath, setContentFilePath] = React.useState("");
  const [currentSource, setCurrentSource] = React.useState(0);
  const [currentFile, setCurrentFile] = React.useState("");


  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    if(open && userObj && userObj.loginId){
      getApiData();
    }
    ///setSaveLoading(false);
    if(open && props.dataObj && props.dataObj.autoId>0){	
      if(props.dataObj.topicId>0 && props.dataObj.topicName!=='null'){
        setTopicId(props.dataObj.topicId);
        setTopicName(props.dataObj.topicName);
      }
      setContentName(props.dataObj.contentName);
      setContentUrl(props.dataObj.contentUrl);
      setDescription(props.dataObj.description);
      setContentType(props.dataObj.contentType);
      handleContentType(props.dataObj.contentType);
      setContentSource(props.dataObj.source);
      setSequence(props.dataObj.sequence);
      setGradeId(props.dataObj.gradeId); 
      setGradeName(props.dataObj.gradeName);
      setLanguage(props.dataObj.language);
      setCountry(props.dataObj.country);
      setContentFilePath("");
      setCurrentSource(props.dataObj.currentSource);
      setCurrentFile(props.dataObj.currentFile);

      if(props.dataObj.hidden===1){
        setHideShow(true);
      }else{
        setHideShow(false);
      }

      if(props.dataObj.topicName && props.dataObj.topicName!=='null' && props.dataObj.topicId>0 && props.dataObj.topicName.length>0){
        setFilterTopics(props.dataObj.topicName);
      }else{
        setFilterTopics("BIO");
      }


    }else{
      if(props.topicId && props.topicId>0){
        setTopicId(props.topicId);
      }else{
        setTopicId(0);
      }      
      if(props.topicName && props.topicName.length>0){
        setTopicName(props.topicName);
        setFilterTopics(props.topicName);
      }else{
        setTopicName("");
        setFilterTopics("BIO");
      }
      setContentName("");
      setContentUrl("");
      setDescription("");
      setContentType("noselect");
      setContentSource("noselect");
      setSequence(1);
      setGradeId(0);
      setGradeName("");
      setLanguage("English");
      setCountry("");
      setContentFilePath("");
      setCurrentSource(0);
      setCurrentFile("");
      setHideShow(false);

    }
	}, [props.dataObj,userObj,open]);

  async function getApiData(){
    let axiosHeader = {
      headers: {
        'Content-Type': 'multipart/mixed',
        'loginId': userObj.loginId,
        'token': userObj.token,
        'device': 'web'					
      }
    };
    let endpoints1 = env.API_URL+"/exams/read/grades";
    let endpoints2 = env.API_URL+"/exams/read/languages?sortby=languageName";

    const axiosrequest1 = axios.get(endpoints1,axiosHeader);
    const axiosrequest2 = axios.get(endpoints2,axiosHeader);

    await axios.all([axiosrequest1, axiosrequest2]).then(axios.spread(function(res1, res2) {
      setGradeList(res1.data.list);
      setLanguageList(res2.data.list);

    }));
  }


	function saveData(){    
    
    if(!topicId){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select topic from left side");			
      return false;
    }
    if(!contentName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter title");			
      return false;
    }  
    if(contentType==='noselect'){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select content type");			
      return false;
    }
    if(contentSource==='noselect'){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select source");			
      return false;
    }
    if(contentSource==='URL' && !contentUrl){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter content URL");			
      return false;
    }else if(contentSource==='URL' && contentType==='Video' && contentUrl && contentUrl.indexOf("youtube.com")===-1){
        setSeverityAlert("error");
        setShowAlert(true);
        setAlertMessage("You can enter youtube video URL only.");			
        return false;        
    }else if(contentSource==='Text' && !description){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter text content");			
      return false;
    }else if(contentSource==='File' && !contentFilePath && !currentFile){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Browse file from your local folder");			
      return false;
    }
    

    
		if(topicId && topicId>0 && contentName && contentName.length>1){  
      setSaveLoading(true);

			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'	
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId>0){
        data.append('id', props.dataObj.autoId);
      }
      data.append('contentName', contentName);
      data.append('topicId', topicId);
      data.append('topicName', topicName);
      data.append('sequence', sequence);

      data.append('language', language);

      if(gradeId && gradeId>0 && gradeName && gradeName.length>0){
        data.append('gradeId', gradeId);
        data.append('gradeName', gradeName);
      }else{
        data.append('gradeId', 0);
        data.append('gradeName', '');
      } 

      if(hideShow===true){
        data.append('hidden', 1);
      }else{
        data.append('hidden', 0);
      } 
      
      if(country!=="noselect"){
        data.append('country', country);
      }else{
        data.append('country', '');
      }
    
      data.append('contentType', contentType);
      data.append('source', contentSource);

      if(contentSource==='URL'){
        data.append('contentUrl', contentUrl);
      }else if(contentSource==='Text'){
        data.append('description', description);
      }else if(contentSource==='File'){
        var myContentFile = document.querySelector('#contentfile');
        if(myContentFile.files[0]){
          data.append("contentFile", myContentFile.files[0]);
        }
      }

      data.append('currentSource', currentSource);
      data.append('currentFile', currentFile);

      let apiURL='/exams/create/topic-contents';
      let myMessage="Content has been created.";
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/exams/update/topic-contents';
          myMessage="Content has been updated.";
      }
             
			axios.post(env.API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          props.updatedList(response.data?.obj?.list);
					return false;
        }else if(response.data.responseTxt==="alreadyexistserror"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This grade name was created earlier. Enter another grade name");
            return false;  					
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Grade name could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	}

  const handleContentType = (val) => {    
    setContentType(val);
    setContentSource("noselect");
    if(val && val==='Video'){
      setContentSourceArr(["URL"]); 
    }else if(val && val==='Text'){
      setContentSourceArr(["Text", "URL"]); 
    }else{
      setContentSourceArr(["File", "URL"]);
    }    
  }
  
  const handleListItemClick = (event, index, obj) => {
		setSelectedIndex(index);
		setTopicName(obj.topicName);
		setTopicId(obj.autoId);
	};

  function handleGrade(val){
    let valArr = val.split('#');
    setGradeId(valArr[0]);
    setGradeName(valArr[1]);
  }


  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
            <div className="btmbdrgry"><h3>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} Content</h3></div>
                  <p>
                  <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                    <tr style={{backgroundColor:'#FFFFFF'}} >
                      <td style={{width:'40%',verticalAlign:'top'}}>
                          <div style={{height:'75vh'}}>
                              <TextField onChange={event => setFilterTopics(event.target.value)} value={filterTopics} placeholder={'Filter Topics'} fullWidth size="small" variant="outlined" />
                              <List component="nav" style={{maxHeight: '65vh', overflow: 'auto'}} aria-label="secondary mailbox folder">
                              {(props.topicsList && props.topicsList.length>0)?props.topicsList.filter(obj => obj.topicName.toLowerCase().startsWith(filterTopics.toLowerCase())).map((row,i)=>(
                                <ListItemButton
                                selected={selectedIndex === i}
                                onClick={(event) => handleListItemClick(event, i, row)}
                                key={'t'+i}
                                >
                                  {selectedIndex === i?
                                  <ListItemIcon>
                                    <CheckIcon />
                                  </ListItemIcon>
                                  :null}  
                                  <ListItemText primary={row.topicName} />
                                </ListItemButton>
                              )):null}                      
                              </List> 
                          </div>
                      </td>
                    <td style={{verticalAlign:'top'}}>
                      <table style={{width:'100%'}} cellSpacing="1" cellPadding="3" >
                        {topicName?
                        <tr style={{fontWeight:'bold'}} >
                            <td>Topic: <span style={{color:'#07449f'}}>{topicName}</span></td>                            
                        </tr>
                        :null}
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setContentName(event.target.value)} value={contentName} label={'Title'} sx={{width:'99%',fontSize: 10}} variant="outlined" />
                            </td>                            
                        </tr> 
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                            <FormControl fullWidth style={{marginTop:5}} >
                              <InputLabel id="type-select-label">Type</InputLabel>
                              <Select 
                                  label="Type"
                                  style={{width:'99%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="type-select-label"
                                  id="select-class"
                                  value={contentType}									
                                  onChange={event => handleContentType(event.target.value)}
                                >
                                    <MenuItem value="noselect">Select Content Type</MenuItem>
                                    <MenuItem value="Video">Video</MenuItem>
                                    <MenuItem value="PDF">PDF</MenuItem>
                                    <MenuItem value="PPT">PPT</MenuItem>
                                    <MenuItem value="Text">Text</MenuItem>
                              </Select>
                            </FormControl>
                              
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                            <FormControl fullWidth style={{marginTop:5}} >
                              <InputLabel id="source-select-label">Source</InputLabel>
                              <Select 
                                  label="Source"
                                  style={{width:'99%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="source-select-label"
                                  id="select-class"
                                  value={contentSource}									
                                  onChange={event => setContentSource(event.target.value)}                                  
                                >
                                    <MenuItem value="noselect">Select Source</MenuItem>
                                    {contentSourceArr?contentSourceArr.map((myRow,mykey)=>(
                                    <MenuItem key={'cntyp'+mykey} value={myRow}>{myRow}</MenuItem>
                                    )):null}
                              </Select>
                            </FormControl>  
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                            {contentSource==='URL'?
                            <TextField onChange={event => setContentUrl(event.target.value)} value={contentUrl} label={'URL'} sx={{width:'99%',fontSize: 10}} variant="outlined" />
                            :contentSource==='Text'?
                            <>

                              <Editor 
                                onEditorChange={(newText) => setDescription(newText)}
                                value={description}
                                onInit={(evt, editor) => editorRef.current = editor}
                                //value={details}
								                //initialValue = { 'asdfasdf' }                                    
                                ///tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                                init={{
                                external_plugins: {
                                  'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`
                                },
                                  height: 500,
                                  selector: 'textarea',
                                  menubar: true,
                                  branding: false,
                                  promotion: false,
                                  //link_context_toolbar: true,
                                  // quickbars_insert_toolbar: true,
                                  //trapFocus: false,
                                  //relative_urls : false,
                                  //remove_script_host: true,                                  
                                  plugins: "advlist lists table paste textcolor colorpicker tabfocus link preview image",
                                  toolbar: "tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry table fontsizeselect bold italic underline forecolor backcolor bullist numlist link preview code", 
                                  imagetools_toolbar: "rotateleft rotateright | flipv fliph | editimage",
                                  convert_urls: false,
                                  draggable_modal: true,                                  
                                  htmlAllowedTags:  ['.*'],
                                  htmlAllowedAttrs: ['.*'],
                                  extended_valid_elements: '*[.*]',
                                  a11y_advanced_options: true,
                                  // image_list: [
                                  //   {title: 'My image 1', value: 'https://www.example.com/my1.gif'},
                                  //   {title: 'My image 2', value: 'http://www.moxiecode.com/my2.gif'}
                                  //   ],
                                    automatic_uploads: true,
                                    images_upload_url: env.API_URL+'/admin-files-upload',
                                      images_reuse_filename: true,
                                      images_file_types: 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp,svg',
                                  // plugins: [
                                  //   'quickbars advlist autolink lists link image charmap print preview anchor',
                                  //   'searchreplace visualblocks code fullscreen',
                                  //   'insertdatetime media table paste code help wordcount searchreplace'
                                  // ], 
                                  // table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                                  // toolbar: 'undo redo | styles | formatselect | searchreplace | ' +
                                  // 'bold italic underline backcolor | link image | alignleft aligncenter ' +
                                  // 'alignright alignjustify | bullist numlist outdent indent | ' +
                                  // 'removeformat | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | help',
                                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                }}
                              />

                            </>
                            :contentSource==='File'?<><input                             
                            className={classes.input}
                            style={{ display: 'none' }}
                            id="contentfile"
                            type="file" 
                            onChange={event => setContentFilePath(event.target.value)}
                          />
                          <label htmlFor="contentfile">
                            <Button component="span" style={{backgroundColor:'#f9c07a',color:'#000', margin: 2}} size="small" variant="contained" >
                              Browse File
                            </Button>   
                            {
                              contentFilePath?
                              <span style={{marginLeft:5}}>{contentFilePath}</span>
                              :contentUrl?<><br/><a href={contentUrl} target="_blank" >{contentUrl}</a></>:null
                            }                         
                          </label></>:null 
                            }                            
                            </td>                            
                        </tr> 
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setSequence(event.target.value)} value={sequence} label={'Sequence'} sx={{width:'99%',fontSize: 10}} variant="outlined" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                            <FormControl fullWidth style={{marginTop:5}} >
                              <InputLabel id="standard-select-label">Grade</InputLabel>
                              <Select 
                                  label="Grade"
                                  style={{width:'99%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="standard-select-label"
                                  id="select-class"
                                  value={gradeId+'#'+gradeName}									
                                  onChange={event => handleGrade(event.target.value)}
                                >
                                    <MenuItem value="0#">Select Grade</MenuItem>
                                    {(gradeList && gradeList.length>0)?gradeList.map((myRow,mykey)=>(
                                      <MenuItem key={'grd'+mykey} value={myRow.autoId+'#'+myRow.gradeName}>{myRow.gradeName}</MenuItem>
                                    )):null}
                              </Select>
                            </FormControl> 
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                            <FormControl fullWidth style={{marginTop:5}} >
                              <InputLabel id="standard-select-label">Language</InputLabel>
                              <Select 
                                  label="Language"
                                  style={{width:'99%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="standard-select-label"
                                  id="select-class"
                                  value={language}									
                                  onChange={event => setLanguage(event.target.value)}
                                >
                                    {(languageList && languageList.length>0)?languageList.map((myRow,mykey)=>(
                                      <MenuItem key={'grd'+mykey} value={myRow.languageName}>{myRow.languageName}</MenuItem>
                                    )):null}
                              </Select>
                            </FormControl> 
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                            <FormControl fullWidth style={{marginTop:5}} >
                              <InputLabel id="country-select-label">Country</InputLabel>
                              <Select 
                                  label="Country"
                                  style={{width:'99%'}}
                                  classes={{ paper: classes.paper }}
                                  labelId="country-class-label"
                                  id="select-class"
                                  value={country}									
                                  onChange={event => setCountry(event.target.value)}
                                >
                                  <MenuItem value="noselect">Select Country</MenuItem>
                                  <MenuItem value="India" >India</MenuItem>
                                  <MenuItem value="Indonesia" >Indonesia</MenuItem>
                                  <MenuItem value="Iran" >Iran</MenuItem>
                                  <MenuItem value="Iraq" >Iraq</MenuItem>
                                  <MenuItem value="Ireland" >Ireland</MenuItem>
                                  <MenuItem value="Israel" >Israel</MenuItem>
                                  <MenuItem value="Italy" >Italy</MenuItem>
                                  <MenuItem value="Uganda" >Uganda</MenuItem>
                                  <MenuItem value="Ukraine" >Ukraine</MenuItem>
                                  <MenuItem value="United Arab Emirates" >United Arab Emirates</MenuItem>
                                  <MenuItem value="United Kingdom" >United Kingdom</MenuItem>
                                  <MenuItem value="United States" >United States</MenuItem>
                                  <MenuItem value="Uruguay" >Uruguay</MenuItem>
                                  <MenuItem value="Uzbekistan" >Uzbekistan</MenuItem>
                                  <MenuItem value="Vanuatu" >Vanuatu</MenuItem>
                                  <MenuItem value="Vatican City" >Vatican City</MenuItem>
                                  <MenuItem value="Venezuela" >Venezuela</MenuItem>
                                  <MenuItem value="Vietnam" >Vietnam</MenuItem>
                                  <MenuItem value="Yemen" >Yemen</MenuItem>
                                  <MenuItem value="Zambia" >Zambia</MenuItem>
                                  <MenuItem value="Zimbabwe" >Zimbabwe</MenuItem>
                              </Select>
                            </FormControl> 
                            </td>                            
                        </tr>

                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                            <FormControlLabel
                                label="Hide"
                                control={
                                  <Checkbox
                                  checked={hideShow}
                                  onChange={(event)=>{setHideShow(event.target.checked)}}
                                  inputProps={{ 'aria-label': 'controlled' }}
                                />
                              }
                              />
                            </td>
                        </tr>    
                        
                      </table>

                          </td>                            
                        </tr>
                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          {saveLoading?
                          <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Saving</LoadingButton>
					    	          :
                          <Button onClick={() => {saveData()}} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Save</Button>
                          }
                      </Box>

                  </p>

            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;